var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isValidBankAccountNumber, isValidUrl } from "framework/helpers";
import { useif } from "../state/types";
import { addString } from "./strings";
import { isEntityErrorsValid, isFieldErrorsValid, NoEntityError, NoFieldError, WholeEntityError } from "./validatableentity";
var DefaultValidator = function (value, reference) { return (__assign({}, NoFieldError)); };
var validateIntGEZ = function (input, message) {
    var value = Number(input);
    return ({
        errors: useif(isNaN(value) || (value % 1) !== 0 || value < 0, message !== null && message !== void 0 ? message : "Očekáváno nezáporné celé číslo"),
    });
};
var validateIntGZ = function (input, message) {
    var value = Number(input);
    return ({
        errors: useif(isNaN(value) || (value % 1) !== 0 || value <= 0, message !== null && message !== void 0 ? message : "Očekáváno kladné celé číslo"),
    });
};
var validateInt = function (input, message) {
    var value = Number(input);
    return ({
        errors: useif(isNaN(value) || (value % 1) !== 0, message !== null && message !== void 0 ? message : "Očekáváno celé číslo")
    });
};
var validateNumberGEZ = function (input, message) {
    var value = Number(input);
    return ({
        errors: useif(isNaN(value) || value < 0, message !== null && message !== void 0 ? message : "Očekáváno nezáporné číslo"),
    });
};
var validateNumberLE = function (input, message, reference) {
    var value = Number(input);
    return ({
        errors: useif(isNaN(value) || value > reference, message !== null && message !== void 0 ? message : ("Očekáváno číslo menší nebo rovno " + reference)),
    });
};
var validateNumber = function (input, message) {
    var value = Number(input);
    return ({
        errors: useif(isNaN(value), message !== null && message !== void 0 ? message : "Očekáváno číslo"),
    });
};
var validateNotEmpty = function (input, message) {
    return ({
        errors: useif(Array.isArray(input) ?
            input.length === 0 :
            input === null || input === undefined || input === "", message !== null && message !== void 0 ? message : "Údaj je vyžadován."),
    });
};
var validateChecked = function (input, message) {
    return ({
        errors: useif(input === null || input === undefined || input === false, message !== null && message !== void 0 ? message : "Údaj musí být nastaven"),
    });
};
var validateEquals = function (input, message, reference) {
    return ({
        errors: useif(input !== reference, message !== null && message !== void 0 ? message : "Údaje musejí být shodné"),
    });
};
var validateUrl = function (input, message) {
    var inp_str = input.toString();
    if (!inp_str.startsWith('https://') && !inp_str.startsWith('http://')) {
        return ({
            errors: message !== null && message !== void 0 ? message : "Adresa webu musí začínat https:// nebo http://",
        });
    }
    var inp_substr = inp_str.replace('https://', '').replace('http://', '');
    if (!inp_substr.includes('.') || inp_substr.endsWith('.')) {
        return ({
            errors: message !== null && message !== void 0 ? message : "Adresa webu musí obsahovat tečku a příponu",
        });
    }
    if (inp_substr.startsWith('.')) {
        return ({
            errors: message !== null && message !== void 0 ? message : "Adresa webu nesmí mít tečku hned za //",
        });
    }
    return ({
        errors: useif(!isValidUrl(input), message !== null && message !== void 0 ? message : "Chybná nebo neúplná adresa webu, uveďte např. https://csts.cz"),
    });
};
var validateBankAccountNumber = function (input, message) {
    return ({
        errors: useif(!isValidBankAccountNumber(input), message !== null && message !== void 0 ? message : "Chybný formát čísla účtu"),
    });
};
var FieldValidationBuilder = /** @class */ (function () {
    function FieldValidationBuilder() {
        this.errors = __assign({}, NoFieldError);
    }
    FieldValidationBuilder.prototype.validateInt = function (input, message) {
        this.errors = FieldValidationBuilder.mergeErrors(this.errors, validateInt(input, message));
        return this;
    };
    FieldValidationBuilder.prototype.validateIntGEZ = function (input, message) {
        this.errors = FieldValidationBuilder.mergeErrors(this.errors, validateIntGEZ(input, message));
        return this;
    };
    FieldValidationBuilder.prototype.validateIntGZ = function (input, message) {
        this.errors = FieldValidationBuilder.mergeErrors(this.errors, validateIntGZ(input, message));
        return this;
    };
    FieldValidationBuilder.prototype.validateNotEmpty = function (input, message) {
        this.errors = FieldValidationBuilder.mergeErrors(this.errors, validateNotEmpty(input, message));
        return this;
    };
    FieldValidationBuilder.prototype.validateNumber = function (input, message) {
        this.errors = FieldValidationBuilder.mergeErrors(this.errors, validateNumber(input, message));
        return this;
    };
    FieldValidationBuilder.prototype.validateNumberGEZ = function (input, message) {
        this.errors = FieldValidationBuilder.mergeErrors(this.errors, validateNumberGEZ(input, message));
        return this;
    };
    FieldValidationBuilder.prototype.validateNumberLE = function (input, than, message) {
        this.errors = FieldValidationBuilder.mergeErrors(this.errors, validateNumberLE(input, message, than));
        return this;
    };
    FieldValidationBuilder.prototype.validateChecked = function (input, message) {
        this.errors = FieldValidationBuilder.mergeErrors(this.errors, validateChecked(input, message));
        return this;
    };
    FieldValidationBuilder.prototype.validateEquals = function (input, reference, message) {
        this.errors = FieldValidationBuilder.mergeErrors(this.errors, validateEquals(input, reference, message));
        return this;
    };
    FieldValidationBuilder.prototype.validate = function (input, reference, validator, message) {
        this.errors = FieldValidationBuilder.mergeErrors(this.errors, validator(input, reference, message));
        return this;
    };
    FieldValidationBuilder.prototype.validateUrl = function (input, message) {
        this.errors = FieldValidationBuilder.mergeErrors(this.errors, validateUrl(input, message));
        return this;
    };
    FieldValidationBuilder.prototype.validateBankAccountNumber = function (input, message) {
        this.errors = FieldValidationBuilder.mergeErrors(this.errors, validateBankAccountNumber(input, message));
        return this;
    };
    FieldValidationBuilder.prototype.isValid = function () {
        return isFieldErrorsValid(this.errors);
    };
    FieldValidationBuilder.prototype.getResult = function () {
        return this.errors;
    };
    FieldValidationBuilder.mergeErrors = function (source1, source2) {
        var output = source1;
        output.errors = addString(output.errors, source2.errors);
        return output;
    };
    return FieldValidationBuilder;
}());
var FieldValidator = function () {
    return new FieldValidationBuilder();
};
var EntityValidationBuilder = /** @class */ (function () {
    function EntityValidationBuilder() {
        this.errors = __assign({}, NoEntityError);
    }
    EntityValidationBuilder.prototype.storeFieldResult = function (field, result) {
        this.errors[field] = result;
    };
    EntityValidationBuilder.prototype.storeEntityResult = function (result) {
        this.errors[WholeEntityError] = result;
    };
    EntityValidationBuilder.prototype.isValid = function () {
        return isEntityErrorsValid(this.errors);
    };
    EntityValidationBuilder.prototype.getResult = function () {
        return this.errors;
    };
    return EntityValidationBuilder;
}());
var EntityValidator = function () {
    return new EntityValidationBuilder();
};
export { DefaultValidator as AlwaysValid, EntityValidator, FieldValidator, validateChecked, validateEquals, validateInt, validateIntGEZ, validateIntGZ, validateNotEmpty, validateNumber, validateNumberGEZ };
